// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import { Inbox } from 'lucide-react'

/** D-UI-3 c5 — "nothing here", said one way everywhere. Only rendered after a SUCCESSFUL load (LoadState). */
export default function EmptyState({ title, hint, action, icon }: { title: string; hint?: ReactNode; action?: ReactNode; icon?: ReactNode }) {
  return (
    <Box role="status" sx={{ textAlign: 'center', py: 4, px: 2, color: 'text.secondary', fontSize: 13 }}>
      <Box sx={{ mb: 1, color: 'text.disabled', display: 'flex', justifyContent: 'center' }}>{icon ?? <Inbox size={22} aria-hidden="true" />}</Box>
      <Box sx={{ fontWeight: 600, color: 'text.primary' }}>{title}</Box>
      {hint && <Box sx={{ mt: 0.5 }}>{hint}</Box>}
      {action && <Box sx={{ mt: 1.5 }}>{action}</Box>}
    </Box>
  )
}
